module.exports = __webpack_public_path__ + "img/ppvr_card_image.1e9820f1.jpg";